<p>apple-pay-verification-component works!</p>
